// extracted by mini-css-extract-plugin
export var contentBody = "_80-9";
export var headerImage = "_80-2";
export var imageButton = "_80-7";
export var imageButtonIcon = "_80-8";
export var imageHeader = "_80-4";
export var imageHeaderText = "_80-5";
export var imageOverlay = "_80-3";
export var imageTitle = "_80-6";
export var imageWrapper = "_80-1";
export var taskList = "_80-a";
export var widget = "_80-0";